import {
  FormEnumFieldWidget,
  FormFieldWidget,
  http,
  ModelFieldType,
  RuntimeEnumerationOption,
  SPI,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import OrderTypeSelect from './OrderTypeSelect.vue';
import { nextTick } from 'vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.Enum,
    widget: 'OrderTypeSelect',
    multi: false
  })
)
export class FormEnumOrderTypeSelectFieldWidget extends FormEnumFieldWidget {
  public initialize(props) {
    super.initialize(props);
    // this.setComponent(OrderTypeSelect);
    return this;
  }

  @Widget.Reactive()
  selectOptions: RuntimeEnumerationOption[] = [];

  @Widget.Reactive()
  protected get options(): RuntimeEnumerationOption[] {
    return this.selectOptions;
  }

  @Widget.Watch('selectOptions', { deep: true })
  watchOptions(val) {
    if (!val.length) {
      this.setValue(null);
    }
  }

  async queryAndSetOptions() {
    this.selectOptions = [];
    const orderType = this.formData.orderType as string;
    const res = (await this.queryOrderType()) as Record<string, string>;
    this.selectOptions = Object.keys(res).map((k) => ({ name: k, displayName: res[k], value: k }));
    if (!this.selectOptions.some((option) => option.value === orderType)) {
      // 默认常规订单
      this.setValue('REGULAR');
    }else{
      this.setValue(orderType);
    }
  }

  async queryOrderType() {
    const buyerPartnerId = this.formData.buyerPartnerId || (this.formData.buyer as any)?.id;
    const gql = `
      mutation {
        sellerDistributionCreateOrderParamMutation {
          fetchOrderType(data: {
            buyerPartnerId: ${buyerPartnerId}
           }) {
            orderType
          }
        }
      }
    `;

    const res = await http.query('deliAriesCoreSeller', gql);

    return res.data.sellerDistributionCreateOrderParamMutation.fetchOrderType.orderType;
  }

  private keepingAttrListOnBuyerChange = [
    'currencyCode',
    'seller',
    'buyer',
    'currency',
    'createOrderMan',
    'ariesUser',
    'originAmount',
    'expectedAmount',
    'actualAmount',
    'activityDiscountAmount',
    'manualDiscountAmount',
    'platformDiscountAmount',
    'shopDiscountAmount',
    'actualShippingFee',
    'settlementAmount'
  ];

  @Widget.Watch('formData.buyer')
  private async onBuyerChange(val, oldVal) {
    // 清除买家或切换买家时
    // 由于买家变更后会调用接口，返回值赋值后会再次触发buyer的watch回调，所有需要关于id的条件判断防止在第二次赋值时清空有效数据
    if (oldVal && val?.id !== oldVal?.id) {
      Object.keys(this.formData).forEach((key) => {
        if (!this.keepingAttrListOnBuyerChange.includes(key)) {
          delete this.formData[key];
        }
      });
    }
  }

  @Widget.Watch('formData.buyerPartnerId')
  private async watchBuyerPartnerId(val) {
    if (val) {
      await this.queryAndSetOptions();
    } else {
      this.selectOptions = [];
    }
  }
}
